import React, {useEffect, useContext, useState} from 'react';
import { useNavigate, Link } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';

const Home = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [renderHTML, setRenderHTML] = useState(false)

  useEffect(() => {
    if(authInformation.autenticado === false){
      // navigate(`/ingreso`);
    } else if( authInformation.autenticado === true){
      if( authInformation.rol === 'Obligado' || authInformation.rol === 'Apoderado' ) {
        navigate(`/notificaciones`);
      }
      else if( authInformation.rol === 'Admin' || authInformation.rol === 'MesaEntrada' ) {
        navigate(`/usuarios`);
      } else {
        // Notificador, Admin, Supervisor
        navigate(`/notificaciones-notificador`);
      }

    }
  }, [authInformation]);

  return (
    <div>
      {/* <h1>Redireccionando</h1> */}
      <div className="row w-75 m-auto">
        <div className="col-sm-6 d-grid">
          <Link
            className="btn btn-primary bg-gradient py-5 mb-3 fs-3"
            to={`/registroPublico`}
            >Registro de Obligado</Link>
            {/* <Link
            disabled={true}
            className="btn disabled btn-primary bg-gradient py-5 mb-3 fs-3"
            to={`/`}
            >Registro de Obligado<br /><span style={{fontSize: '1rem'}}>( habilitado a partir del 1 de abril )</span>
            </Link> */}
            
        </div>
        <div className="col-sm-6 d-grid">
          <Link
            className="btn btn-warning bg-info py-5 mb-3 fs-3"
            to={`/ingreso`}
            >Ingreso</Link>
        </div>

      </div>
    </div>
  );
};

export default Home;